import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PermissionGroupItem } from "@/actions/ssr/settings/getPermissionGroupsSSR";

interface PermissionGroupsState {
  items: PermissionGroupItem[];
  totalPages: number;
  currentPage: number;
  totalItems: number;
}

const initialState: PermissionGroupsState = {
  items: [],
  totalPages: 1,
  currentPage: 1,
  totalItems: 0,
};

const permissionGroupsSlice = createSlice({
  name: "permissionGroups",
  initialState,
  reducers: {
    setPermissionGroupItems(
      state,
      action: PayloadAction<PermissionGroupItem[]>,
    ) {
      state.items = action.payload;
    },
    setPermissionGroupPagination(
      state,
      action: PayloadAction<{
        totalPages: number;
        currentPage: number;
        totalItems?: number;
      }>,
    ) {
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      if (action.payload.totalItems !== undefined) {
        state.totalItems = action.payload.totalItems;
      }
    },
  },
});

export const { setPermissionGroupItems, setPermissionGroupPagination } =
  permissionGroupsSlice.actions;
export default permissionGroupsSlice.reducer;
